import { OAuth2Client } from '@kolorado/oauth';
import { EnvironmentVariableType } from '../../process-environment';
import { AuthInfo } from '../../globals/authentication/types';

export enum loginActionNames {
  SET_LOGIN_PENDING = 'SET_LOGIN_PENDING',
  SET_LOGIN_SUCCESS = 'SET_LOGIN_SUCCESS',
  SET_LOGIN_ERROR = 'SET_LOGIN_ERROR',
  SET_LOGOUT = 'SET_LOGOUT',
  SET_CLIENT = 'SET_CLIENT',
  SET_ENV_VARIABLES = 'SET_ENV_VARIABLES',
}
export interface LoginState {
  isLoginSuccess: boolean;
  isLoginPending: boolean;
  loginError: any;
  client: OAuth2Client | null;
  envVariables: EnvironmentVariableType;
  authInfo: AuthInfo | null;
}

interface SetLoginPending {
  type: typeof loginActionNames.SET_LOGIN_PENDING;
  payload: boolean;
}

interface SetLoginSuccess {
  type: typeof loginActionNames.SET_LOGIN_SUCCESS;
  payload: boolean;
}

interface SetLoginError {
  type: typeof loginActionNames.SET_LOGIN_ERROR;
  payload: boolean;
}

interface SetLogout {
  type: typeof loginActionNames.SET_LOGOUT;
  payload: boolean;
}

interface SetClient {
  type: typeof loginActionNames.SET_CLIENT;
  payload: OAuth2Client;
}

interface SetEnvironmentVariables {
  type: typeof loginActionNames.SET_ENV_VARIABLES;
  payload: EnvironmentVariableType;
}

export type LoginActionTypes =
  | SetLoginPending
  | SetLoginSuccess
  | SetLoginError
  | SetLogout
  | SetClient
  | SetEnvironmentVariables;
